// Guaubuelo: microanimaciones que ayudan a comprar. Sin librerías.
import { StandardEvents } from '@shopify/events';

const calma = window.matchMedia('(prefers-reduced-motion: reduce)');

// 1. «✓ Añadido» y rebote del carrito, solo cuando Horizon confirma el añadido
const ANADIDO_MS = 1200;
const textoAnadido = 'Añadido';

document.addEventListener(StandardEvents.cartLinesUpdate, (evento) => {
  if (evento.action !== 'add' || !evento.promise) return;
  const formulario = evento.target instanceof Element ? evento.target.closest('product-form-component') : null;
  evento.promise
    .then((resultado) => {
      if (resultado?.detail?.didError) return;
      const botones = new Set();
      formulario?.querySelectorAll('.add-to-cart-button').forEach((b) => botones.add(b));
      // La barra fija de Horizon pulsa el botón original: también se marca
      if (formulario?.closest('.product-information, product-information, main')) {
        document.querySelectorAll('.sticky-add-to-cart__button').forEach((b) => botones.add(b));
      }
      for (const boton of botones) {
        boton.dataset.gbAnadido = textoAnadido;
        boton.classList.add('gb-anadido');
        clearTimeout(boton.gbTemporizador);
        boton.gbTemporizador = setTimeout(() => boton.classList.remove('gb-anadido'), ANADIDO_MS);
      }
      if (!calma.matches) {
        document.querySelectorAll('.header-actions__cart-icon').forEach((icono) => {
          icono.classList.remove('gb-rebote');
          void icono.offsetWidth;
          icono.classList.add('gb-rebote');
          icono.addEventListener('animationend', () => icono.classList.remove('gb-rebote'), { once: true });
        });
      }
    })
    .catch(() => {});
});

// 3. Cambio de variante: el precio y la foto entran con un fundido breve
const FUNDIDO = { duration: 300, easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)' };
let ultimaVariante = 0;
document.addEventListener(StandardEvents.productSelect, () => {
  ultimaVariante = Date.now();
});
const fundir = (elemento) => {
  if (calma.matches || Date.now() - ultimaVariante > 3000 || !elemento?.animate) return;
  elemento.animate([{ opacity: 0.35 }, { opacity: 1 }], FUNDIDO);
};
const vigilarVariante = new MutationObserver((cambios) => {
  const hechos = new Set();
  for (const cambio of cambios) {
    const destino = cambio.target.closest?.('product-price, .product-information__media');
    if (destino && !hechos.has(destino)) {
      hechos.add(destino);
      fundir(destino);
    }
  }
});
document.querySelectorAll('product-price, .product-information__media').forEach((elemento) => {
  vigilarVariante.observe(elemento, { childList: true });
});
